import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Since 2019, what key strategies have you implemented to accelerate EBank’s growth
                and strengthen its market position?
              </strong>
            </h5>

            <h5 className="text-white">
              <br />• EBank issued its first Five-Year Strategic Plan 2017/2022, which included many
              goals and pillars requiring the creation of new departments and functions while
              changing the image and culture of the Bank corresponding with the Strategy vision and
              objectives. This period witnessed several developments and challenges that required
              EBank to be a more agile and smart Bank to be able to keep pace with the changing
              markets and competition with the entry of new competitors of different nature
              characterized by speed and development.
              <br />• EBank moved forward with steady and ambitious steps to achieve its vision of
              providing various high-quality services and products through a wide network of
              advanced branches and ATMs spread all over Egypt, while using modern technology and
              developing the human capital. Accordingly, for the first time Net Profit of one
              billion Egyptian pounds were achieved in 2019 in EBank history.
              <br />• With the Bank’s success in achieving the objectives of the first Strategic
              Plan, the Bank Management embarked on the preparation of a new Strategic Plan during
              2022 for the next five years, ending in 2027, as such complementing the previous plan
              and pillars and adopting new pillars aligned with the current developments in the
              banking market.
              <br />• EBank started to introduce services oriented towards using modern technology
              tools in the services and products that the Bank offers in parallel with changing the
              Bank’s corporate identity from EBE to EBank, which reflects Export, Digitization and
              Excellence in line with EBank’s forwardlooking vision. In addition, the State’s
              directives and its goal to achieve exports worth US$100 billion by 2030 were taken
              into account. We also participated in the various CBE initiatives that encourage and
              motivate diverse market sectors and activities for both corporate and retail
              customers.
              <br />• EBank authorized Capital is EGP 20 billion by December 2024, while the issued
              and paid-up capital amounts to EGP 9.9 billion. EBank’s shares are wholly of nominal
              value and indivisible, with a nominal value of EGP 10 per share.
              <br />• EBank Total Assets increased from EGP 50,681 M in 2019to EGP 181,867 M in 2024
              with growth rate of 259%, which indicates the banks’ ability to expand operations and
              sustainable growth.
              <br />• Gross Loans also increased by 184% from EGP 26,294 M in 2019 to EGP 74,735 M
              in 2024 indicates better market position.
              <br />• Customer deposits increased by 239% from EGP 40,524 M in 2019 to EGP 137,305 M
              in 2024, which reflect strong customer confidence & financial stability.
              <br />• EBank primary vision is to provide and maintain their diversified services and
              products at a high quality through its well spread network of branches attracting new
              customers in which we moved from 36 to 45 branches from 2019- 2024.
              <br />• ATMs placed throughout Egypt & digital channels along with their network and
              corresponding banks aboard to spread by 131% from 52 to 120 ATMs from 2019-2024.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Financial inclusion and sustainability are vital to Egypt’s economic development.
                How do you integrate financial inclusion and sustainability principles into Ebank’s
                strategic plans?
              </strong>
            </h5>
            <h5 className="text-white">
              EBank vision is to be among the top 5 banks in delivering distinguished Financial
              Inclusion products to youth and women, while driving positive economic and social
              impact, increasing EBank profitability, and expanding market share. Financial
              inclusion main pillars are:
              <br />
              <br />
              <b>1- Financial Literacy:</b>
              <br />
              <br />• Increase awareness about financial literacy regarding EBank’s products and
              services among both Egyptian citizens and EBank employees.
              <br />• Educate customers, youth, and women with foundational financial literacy
              skills, covering essential concepts such as budgeting, saving, and investing.
              <br />• Empower customers to make informed financial decisions. ConfidentiaL
              <br />• Promote digital financial literacy & Online banking usage.
              <br />• Develop future exporters’ banking knowledge and equipping them with the needed
              financial & non-financial services.
              <br />
              <br />
              <b>2- Entrepreneurship:</b>
              <br />
              <br />• Support & promote Entrepreneurship among individuals & small businesses in
              Egypt
              <br />• Provide access to financial mentorship & training for aspiring entrepreneurs.
              <br />• Encourage innovation & business growth within the community.
              <br />• Facilitate networking opportunities for entrepreneurs to connect with industry
              experts & potential investors.
              <br />• Empower future exporters by providing comprehensive support to entrepreneurs,
              with a focus on youth and women, through targeted training and guidance programs,
              specifically targeting youth and women aged 15 to 35 years.
              <br />
              <br />
              <b>3- Digital Transformation:</b>
              <br />
              <br />• Youth-Centric Product Development
              <br />• Empowering Women Financial Health
              <br />• Fueling Entrepreneurship
              <br />• Inclusive Banking for Persons with Disabilities (PWD)
              <br />• Expanding reach in rural areas
              <br />
              <br />
              With the issuance of the Guiding Principles on Sustainable Finance in 2021, followed
              by legally binding regulations in 2022, the CBE has set a clear framework for Egyptian
              banking sector to integrate ESG (Environmental, social & governance) considerations
              into their operations.
              <br />
              <br />• These efforts reflect Egypt’s commitment to a sustainable, low-carbon economy
              while ensuring the resilience of its financial system.
              <br />• Building on the 2021 CBE Guiding Principles, EBank adopts sustainable lending
              and investment policies, establish dedicated sustainability department, and report on
              Sustainability performance.
              <br />• In fact, EBank integrates ESG considerations into their credit risk
              assessments, engage environmental experts for large-scale projects, and ensure Board
              oversight of sustainability initiatives to support green economic growth.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Strategic planning often involves spearheading transformative projects. Can you
                share a key project you’ve led that had a significant impact on the bank’s business
                model or market positioning?
              </strong>
            </h5>
            <h5 className="text-white">
              EBank succeeded in launching the core banking system upgrade, which had a significant
              impact on EBank efficiency and overall market competitiveness. The key impacts and
              challenges are:
              <br />
              <br />• Faster processing and transactions.
              <br />• Automation and cost reduction.
              <br />• Improved customer experience.
              <br />• Scalability and innovation.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Ebank serves a diverse range of clients, from SMEs to multinational corporations.
                How do you tailor your strategic initiatives to meet the unique needs of both SMEs
                and corporate clients?
              </strong>
            </h5>
            <h5 className="text-white">
              EBank objective is to offer specially designed products for micro, small and medium
              companies according to the size of the company and the nature of its business by:
              <br />
              <br />• Reviewing the return on the existing corporate facilities portfolio.
              <br />• Concluding cooperation protocols with government agencies to maximize the
              target customer base.
              <br />• New industrial markets penetration to diversify the lending portfolio and
              focusing on strategic industries, export-oriented manufacturing industries and
              industries that replace imports with local products.
              <br />• The NilePreneurs Initiative to provide non-financial services that aim to
              achieve economic growth for entrepreneurs.
              <br />• Expanding and diversifying the Bank customer base, especially exporters or
              their partners who belong to the supply/value chain.
              <br />• Offering specialized products such as products aligning with the nature of the
              new markets, especially emerging projects that support women and entrepreneurs.
              <br />• EBank target is to be the customer’s first choice by providing financial and
              non-financial services. This can be tailored through:
              <br />• Increasing the customer base in a selective manner by focusing on emerging
              companies operating in strategic industries with a focus on maximizing return on
              assets.
              <br />• Promoting cross selling of various products to maximize the business and
              improve returns.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- With extensive experience across retail and corporate banking, how has your
                background shaped your approach to strategic planning and helped align Ebank’s
                services with market demands
              </strong>
            </h5>
            <h5 className="text-white">
              <br />• EBank approach is to identify the segments of high-net-worth customers,
              determining the population composition of financial inclusion, entrepreneurs, women
              and young exporters.
              <br />• Build a Center of Excellence for customer engagement while maximizing
              operational efficiency by optimizing the use of Artificial Intelligence (AI) and
              establishing a unified platform to provide flexible services to customers.
              <br />• Motivating customers to use digital channels.
              <br />• Identifying new sites, especially in new cities and industrial areas.
              <br />• Increasing the number of branches to 65 by the end of the Strategic Plan.
              <br />• Increasing the number of Automated Teller Machines (ATMs) to reach 100, in
              addition to developing and supporting them with Interactive Teller Machines (ITMs).
              <br />• Measuring customer satisfaction by using automated programs for customer
              complaints and suggestions, along with simplifying the procedures of launching fast
              products and services regarding customer requests.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Export promotion is a key focus of Egypt’s national agenda. What’s your vision
                for Ebank’s role in supporting Egyptian exports and contributing to Egypt’s economic
                development?
              </strong>
            </h5>
            <h5 className="text-white">
              Export development is one of the main pillars of EBank strategy, the main objective is
              to create a competitive advantage by providing a full range of financial and
              non-financial services to customers, especially the exporter segment, by establishing
              an exclusive club for exporters that provides them with specialized services package.
              <br />
              <br />
              EBank established export club and it offers financial and non-financial services
              tailored to exporters needs. It provides the below services:
              <br />
              <br />• Supporting clients finding potential buyers through access to our exclusive
              portal and partnerships with trade brokers.
              <br />• Fast track lending to meet exporters needs.
              <br />• Partnerships with logistic service providers and insurance service providers
              to offer our members unique rates and fast TAT. ConfidentiaL
              <br />• A network of events and training on various exporting topics.
              <br />• Discounts on exporting fees and commissions.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Process optimization is crucial for delivering efficiency in banking services.
                How do you integrate process reengineering into Ebank's strategic initiatives to
                improve operational performance and customer experience?
              </strong>
            </h5>
            <h5 className="text-white">
              Process re-engineering is essential for enhancing efficiency, reducing costs and
              improving customer experience by:
              <br />
              <br />• Digital Transformation and Automation.
              <br />• Streamlined customer experience and self-service.
              <br />• Branch and ATM optimization.
              <br />• Data driven decision making
              <br />• Process standardization and compliance efficiency
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Digital transformation is reshaping the banking sector globally. How is digital
                innovation integrated into Ebank’s strategic planning to enhance operational
                efficiency and improve customer experience?
              </strong>
            </h5>
            <h5 className="text-white">
              Preparing the Bank’s strategy for Digital banking services by:
              <br />
              <br />
              <br />• Expanding the customer base by attracting new customers while maintaining
              existing customer engagement.
              <br />• Changing the banking concept in Egypt through innovative solutions.
              <br />• Using the Bank website as a channel for selling and promoting products and
              e-banking services.
              <br />• Automating transactions and procedures to improve service quality.
              <br />• Directing and motivating customers to perform their transactions through
              digital, rather than traditional, channels.
              <br />• Offering distinguished digital products and services mainly based on the
              optimal use of modern technology.
              <br />• Opening small branches and digital bank branches to meet the needs of
              customers in remote geographical areas or seasonal locations.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
